import { cn } from '@/lib/utils';
import { renderGfmPanelMarkdown } from '@/lib/gfmPanelMarkdown';

/**
 * Renders panel markdown (GFM tables, lists, headings) for Integration Suite and similar rails.
 */
export default function PanelMarkdown({ content, className }) {
  const nodes = renderGfmPanelMarkdown(content);
  if (!nodes.length) {
    return <span className="text-muted-foreground">—</span>;
  }

  return (
    <div className={cn('panel-markdown text-sm leading-relaxed text-cp-fg', className)}>{nodes}</div>
  );
}
